export default __webpack_public_path__ + "static/media/iconmonstr-magnifier-4.f38bc1fe.svg";